<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 900px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">{{ title }}</h3>
      <div class="header-actions">
        <i class="fa" [ngClass]="{'fa-plus-square-o': taskModalMinimise, 'fa-minus-square-o': !taskModalMinimise}"
           style="margin-right: 10px; cursor: pointer;" [title]="taskModalMinimise ? 'Maximize' : 'Minimize'"
           (click)="taskModalMinimise = !taskModalMinimise"></i>
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>

    <div class="modal-body" [hidden]="taskModalMinimise">
      @if (taskLoading) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
      </div>
}

      @if (!taskLoading) {
<div>
        <div class="row row-gray-callOut">
          <div class="row" style="margin: 10px 5px 0 5px;">
            <div class="col-md-3">
              <label>App Key: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Select App Key (Channel)" direction="top"></i></label>
              <select class="form-control" [(ngModel)]="taskForm.channel" [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="onChannelChange()">
                @for (s of channelList; track $index) {
<option [ngValue]="s">{{ s.channel_name }}</option>
}
              </select>
            </div>
            <div class="col-md-3">
              <label>Parent Task</label>
              <select class="form-control" [(ngModel)]="taskForm.parentTask" [ngModelOptions]="{standalone: true}">
                <option value="">none</option>
                @for (task of modalTaskList; track $index) {
<option [ngValue]="task.task_key">{{ task.indent }}{{ task.task_name }}</option>
}
              </select>
            </div>
          </div>
        </div>

        <div class="row" style="margin: 10px 5px 0 5px;">
          @if (mode === 'edit') {
<div class="col-md-2">
            <label>Task Key:</label>
            <div>{{ taskForm.task_key }}</div>
          </div>
}
          <div class="col-md-2">
            <label>Task Name: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Enter task name" direction="top"></i></label>
            <input type="text" class="form-control" placeholder="enter task name"
                   [(ngModel)]="taskForm.task_name" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="col-md-3">
            <label>Task Description: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Enter task description" direction="top"></i></label>
            <textarea class="form-control" placeholder="enter task description" rows="2" maxlength="2000"
                      [(ngModel)]="taskForm.task_desc" [ngModelOptions]="{standalone: true}"></textarea>
          </div>
          <div class="col-md-2">
            <label>Task Priority: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Enter priority" direction="top"></i></label>
            <input type="number" class="form-control" placeholder="enter priority"
                   [(ngModel)]="taskForm.task_priority" [ngModelOptions]="{standalone: true}">
          </div>
          <div class="col-md-2">
            <label>Task Status: <i class="fa fa-info-circle" ap-tooltip [appendAfterTarget]="true" tooltipContent="Active or Inactive" direction="top"></i></label>
            <select class="form-control" [(ngModel)]="taskForm.task_status" [ngModelOptions]="{standalone: true}">
              @for (s of statusList; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
            </select>
          </div>
        </div>
      </div>
}
    </div>

    <div class="modal-footer" [hidden]="taskModalMinimise">
      <button class="btn btn-primary btn-sm" type="button" (click)="save()" [disabled]="crudLoading">
        Save @if (crudLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
      </button>
      <button class="btn btn-info btn-sm" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-info btn-sm" type="button" (click)="clearForm()">Clear Form</button>
    </div>
  </div>
</div>
